<template>
  <div>
    <app-header />
    <mpn-page-title title="마이팩 신청 완료" />

    <!-- S : main -->
    <main class="a-service-main">
      <!-- S : 컨텐츠 영역 -->
      <div class="a-service-container">
        <div class="mypack_complete">
          <complete-common-info
            :center-location="statusDetail.abc_name"
            :cfm-kind="statusDetail.cfm_kind"
            :pack-status="statusDetail.pack_status"
            @on-reservation-info="onReservationInfo"
          />

          <!-- S : 공통 타이틀 영역 -->
          <mpn-section-title>신청내역</mpn-section-title>
          <!-- E : 공통 타이틀 영역 -->

          <!-- S : 신청내역 상세정보 ex)신청일, 팩 이름 -->
          <complete-application-info-detail
            :applied-date="statusDetail.req_date"
            :pack-name="statusDetail.mypack_name"
            :billing-date="statusDetail.billing_date"
            :billing-period="statusDetail.billing_period"
          />
          <!-- E : 신청내역 상세정보 ex)신청일, 팩 이름 -->

          <!-- S : 최종 선택 제품 정보 -->
          <final-applied-item-info
            active-button=""
            :final-products="productsDetails"
            :days="days"
            :pockets="pockets"
            :prices="prices"
          />
          <!-- E : 최종 선택 제품 정보 -->
        </div>
        <main-button-group
          title-left="신청내역 확인"
          title-right="마이팩 메인"
          @click-left="proceedNext"
          @click-right="$router.push('/')"
        />
      </div>
      <!-- E : 컨텐츠 영역 -->
      <!-- S : 플로팅 버튼 -->
      <floating-button-group
        title-left="신청내역 확인"
        title-right="마이팩 메인"
        @click-left="proceedNext"
        @click-right="$router.push('/')"
      />
      <!-- E : 플로팅 버튼 -->
      <modal-reservation ref="refModal" />
    </main>
    <!-- E : main -->

    <app-footer />
  </div>
</template>

<script>
import { log } from '@/utils/common';
import AppHeader from '@/components/AppHeader.vue';
import AppFooter from '@/components/AppFooter.vue';
import FloatingButtonGroup from '@/components/FloatingButtonGroup.vue';
import FinalAppliedItemInfo from '@/components/final-check/FinalAppliedItemInfo.vue';
import MainButtonGroup from '@/components/MainButtonGroup.vue';
import ModalReservation from '@/components/modal-popups/ModalReservation.vue';
import CompleteCommonInfo from './partial/CompleteCommonInfo.vue';
import CompleteApplicationInfoDetail from './partial/CompleteApplicationInfoDetail.vue';
import orderApi from '@/apis/order'

export default {
  name: 'CompositionComplete',
  components: {
    AppHeader,
    AppFooter,
    FloatingButtonGroup,
    CompleteCommonInfo,
    CompleteApplicationInfoDetail,
    FinalAppliedItemInfo,
    MainButtonGroup,
    ModalReservation,
  },
  props: {
    appliedStateDetail: {
      type: Object,
      default: null,
    },
    productsDetails: {
      type: Array,
      default: () => [],
    },
    pockets: {
      type: Number,
      default: 0,
    },
    days: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {

    };
  },
  computed: {
    statusDetail() {
      return this.appliedStateDetail;
    },
    prices() {
      return {
        price: this.statusDetail.total_price,
        pv: this.statusDetail.total_pv,
        bv: this.statusDetail.total_bv,
      };
    },
  },
  created() {
    this.$store.dispatch('context/unset');
    this.$store.dispatch('agreement/init');
    this.$store.dispatch('payment/reset');
  },
  methods: {
    async proceedNext() {
      const orderToken = await orderApi.getOrderToken(this.statusDetail.req_no, false, null)
      this.$store.commit("order/updateOrderToken", orderToken)
      await this.$router.push(`/mypacks/${this.statusDetail.req_no}`);
    },
    onReservationInfo() {
      this.$refs.refModal.open();
    },
  },
};
</script>
